import {Avatar, Box, Stack, Typography} from "@mui/material";
import {IconWaveSine} from "@tabler/icons-react";
import {grey} from "@mui/material/colors";
import React from "react";
import AreaChart from "./AreaChart";

export const MiniCard = ({subtitle, title, icon: Icon = IconWaveSine, data = [], color = "#3f51b5", hideChart = false}) => {
  return (
    <Stack direction="column" gap={0} sx={{borderRadius: 3}} className={"border-shadow"}>
      <Stack direction={"row"} gap={2} sx={{p: 2, pb: 0}}>
        <Box>
          <Avatar sx={{color: color, p: 1, bgcolor: `${color}15`, fontSize: "2rem"}} size={"small"}
                  className={"border-shadow"}>
            <Icon/>
          </Avatar>
        </Box>
        <Box>
          <Typography variant={"body1"} color={grey[500]}>{subtitle}</Typography>
          <Typography variant={"h3"} fontWeight={600}>{title}</Typography>
        </Box>
      </Stack>
      <Box id={"parent-box"} sx={{minHeight: "10dvh", maxHeight: "110px"}}>
        <Box sx={{mt: "-22px", ml: "-4%"}}>
          {hideChart ? null : <AreaChart data={data} colors={[color]} label={subtitle}/>}
        </Box>
      </Box>
    </Stack>
  )
}
